import { default as React } from "react";

import { WithTranslation, withTranslation } from "react-i18next";
import { MaxNetPosDto, MaxExchangesDto } from "core/backend/data";
import { MultiSelectItem } from "components/multiselect";
import { ResponsiveLine, Serie } from "@nivo/line";

interface OwnProps {
    scrollPosition?: { col: number, row: number };
    maxNetPosData: MaxNetPosDto[];
    maxExchangeData: MaxExchangesDto[];
    hubs: MultiSelectItem[];
    borders: MultiSelectItem[];
}

const List = ({ t, maxNetPosData, maxExchangeData, scrollPosition, hubs, borders }: OwnProps & WithTranslation) => {
    // const keysInDto = keys<MaxExchangesDto>();
    const dtoBorders = borders;//.filter((x) => keysInDto.some((key) => key.toLowerCase().endsWith(x.id.toLowerCase())));

    const graph = (paired: boolean, data: Serie[]) => (
        <ResponsiveLine
            data={data}
            margin={{ top: 50, right: 110, bottom: 50, left: 60 }}
            xScale={{ type: "point" }}
            yScale={{ type: "linear", min: "auto", max: "auto", stacked: false, reverse: false }}
            axisBottom={{
                orient: "bottom",
                tickSize: 5,
                tickPadding: 5,
            }}
            axisLeft={{
                orient: "left",
                tickSize: 5,
                tickPadding: 5,
            }}
            enableGridX={false}
            colors={paired ? { scheme: "paired" } : { scheme: "category10" }}
            enablePoints={false}
            isInteractive={false}
            enableCrosshair={false}
            legends={[
                {
                    anchor: "right",
                    direction: "column",
                    justify: false,
                    translateX: 100,
                    translateY: 0,
                    itemsSpacing: 0,
                    itemDirection: "left-to-right",
                    itemWidth: 80,
                    itemHeight: 20,
                    itemOpacity: 0.75,
                    symbolSize: 10,
                    symbolShape: "circle",
                    symbolBorderColor: "rgba(0, 0, 0, .5)",
                }
            ]}
        />
    );
    const drawExchangeGraph = (hub: string) => {
        return <div key={hub} className="shadow-sm bg-white rounded" style={{ position: "relative", width: "500px", height: "250px", margin: "0.5rem" }}>
            <div style={{ position: "absolute", textAlign: "center", top: "15px", width: "500px" }}>Max bilateral exchanges from {hub} (MW)</div>
            {graph(false,
                dtoBorders
                    .filter(b => b.id.startsWith(hub + "_"))
                    .sort((a, b) => b.id.localeCompare(a.id)) // descending
                    .map(b => {
                        return {
                            id: "Max " + b.text,
                            data: maxExchangeData
                                .map((m) => { return { x: new Date(m.dateTimeUtc).getHours() + 1, y: eval("m.border_" + b.id) }; })
                        };
                    })
            )}
        </div>;
    };

    return (
        <div style={{ display: "flex", flexWrap: "wrap", margin: "0rem" }}>
            {hubs.filter(f => f.id != "ALBE" && f.id != "ALDE").map(h => drawExchangeGraph(h.id))}
            <div className="shadow-sm bg-white rounded" style={{ position: "relative", width: "1000px", height: "700px", margin: "0.5rem" }}>
                <div style={{ position: "absolute", textAlign: "center", top: "15px", width: "1000px" }}>Min/Max net positions (MW)</div>
                {graph(true, hubs
                    .sort((a, b) => b.id.localeCompare(a.id)) // descending
                    .reduce((arr: Serie[], h) => {
                        return arr.concat([
                            { id: "Max " + h.id, data: maxNetPosData.map((m) => { return { x: new Date(m.dateTimeUtc).getHours() + 1, y: eval("m.max" + h.id) }; }) },
                            { id: "Min " + h.id, data: maxNetPosData.map((m) => { return { x: new Date(m.dateTimeUtc).getHours() + 1, y: eval("m.min" + h.id) }; }) },
                        ], []);
                    }, []))}
            </div>
        </div>
    );
};

const translated = withTranslation()(List);

export default translated;